import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppContent from 'shared/components/AppContent';
import { routes } from 'shared/constants/routes';
import List from './List';
import ListV2 from './ListV2';

function StatisticsRoutes() {
  return (
    // <AppContent>
    <Switch>
      <Route path={[routes.statistics.v2.path]}>
        <ListV2 />
      </Route>
      <Route path={[routes.statistics.default.path]}>
        <ListV2 />
        {/* <List /> */}
      </Route>
    </Switch>
    // </AppContent>
  );
}

export default StatisticsRoutes;
